require('file-loader?name=[name].[ext]!./index.html');

require('file-loader?name=[name].[ext]!./index.html');
require('file-loader?name=[name].[ext]!./index-dev.html');

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from '../src/components/App.jsx';

import './index.css';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root'),
);
